/* eslint-disable jsdoc/require-jsdoc */
/* eslint-disable import/consistent-type-specifier-style */
import { Lazy } from '@studio/js-utils/async';
import { createHook, type Producer, type Store } from '@studio/react-utils/store';
import type { T_Any, T_Optional } from '@tryiris-ai/js-types';
import type { Mutate } from 'zustand';
import { subscribeWithSelector } from 'zustand/middleware';
import { immer } from 'zustand/middleware/immer';
import { createStore } from 'zustand/vanilla';

export const DEADBAND_MARGIN_X = 0.1;
export const DEADBAND_MARGIN_Y = 0.1;

interface T_InternalState {
  deadbandDimensions: { height: number; width: number };
  deadbandOverrides: T_Optional<{ commit: boolean; height: number; width: number }>;
  produce: Producer<T_InternalState>;
}

/** Lazily loaded deadband. */
const __deadband = new Lazy(() =>
  createStore<T_InternalState>()(
    immer(
      subscribeWithSelector((set) => ({
        produce: (fn: (draft: T_InternalState) => void): void => {
          set(fn);
        },

        deadbandOverrides: {},
        deadbandDimensions: { width: 0, height: 0 }
      }))
    )
  )
);

/** Deadband proxy. */
const deadbandDimensionsProxy = new Proxy<
  Mutate<Store<T_InternalState>, [['zustand/subscribeWithSelector', never]]>
>(<T_Any>{}, {
  get(...args): unknown {
    return Reflect.get(__deadband.value, args[1], args[2]);
  }
});

export const deadbandDimensions = createHook(deadbandDimensionsProxy);
